import React, { useEffect } from 'react';
import CusGreenBtn from '../components/CusGreenBtn';
import FormContainer from '../components/FormContainer';
import SubHeader from '../components/SubHeader';
import img1 from '../images/appCancel.png';
import config from '../appconfig/config.json';

const AppCancelled = (props) => {
    useEffect(() => {
        console.log('@AppCancelled useEffect');

        window.scrollTo(0, 0);
         
    }, []);

    const handleBacktoHome = () => {

        window.location.href = config.link.BacktoHome;
    }

    return (
        <div className="container-fluid">
            <SubHeader title={'The financing application has been cancelled'} />  
            <FormContainer>
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <div><img className="imgScc" src={img1} alt="imgScc1"></img></div>
                    <div style={{color:'#585858',paddingTop:'10px',fontWeight:'500'}}>Application<br/>Cancelled</div>
                    <br/><br/>
                    <div style={{color:'#808080'}}>You may reapply anytime.</div>
                    <br/>
                    <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome}  />
                    <br/> 
                </div>
            </FormContainer>
            <br/><br/><br/>
        </div>
    )

}

export default AppCancelled;